var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.209209 0.209209C0.488155 -0.0697365 0.940308 -0.0697365 1.21925 0.209209L6.21925 5.20921C6.4982 5.48816 6.4982 5.94031 6.21925 6.21925L1.21925 11.2193C0.940308 11.4982 0.488155 11.4982 0.209209 11.2193C-0.0697364 10.9403 -0.0697362 10.4882 0.209209 10.2092L4.70419 5.71423L0.209209 1.21925C-0.0697365 0.940308 -0.0697365 0.488155 0.209209 0.209209Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.7e9ce256a64e914ec6e46480bf939996.svg";
export { ForwardRef as ReactComponent };